import { useContextComissoes } from "src/Contexts/comissoes/ComissoesContext";
import { useConfigPageContext } from "src/Contexts/configPagesContext/configPagesContext";
import { useLayoutMainContext } from "src/Contexts/MainLayoutContext";
import { api } from "src/shared/setup/API/api";

export const useHttpTableAdministradora = () => {
  const { setQtdRegisters, setLoadingTable } = useConfigPageContext();
  const { setListAdministradora } = useContextComissoes();
  const { handleGetAlert } = useLayoutMainContext();

  const handleGet = async () => {
    setLoadingTable(true);

    api
      .get("/administrators/all")
      .then((res) => {
        setListAdministradora(res.data.data);
        setQtdRegisters(res.data.meta.total);
      })
      .catch((error) =>
        handleGetAlert({ message: error.response.data.message })
      )
      .finally(() => setLoadingTable(false));
  };

  return { handleGet };
};
